import React, { useEffect, useMemo, useRef, useState } from 'react';
import { addData, deleteFileByUrl, getData, handleFireBaseUpload } from '../Firebase/firestore';
import { db } from '../firebase';
import './resources.css'
import './main.css'
import './tuxedo.css'
import sh from '../assets/search.png'

function Tuxedo_upload() {
    const [formData, setFormData] = useState({
        name: '',
        resources: [],
        fabricId: ''
    });

    const [Tuxedo, setTuxedo] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadTotal, setUploadTotal] = useState(0);
    const [uploadStatus, setUploadStatus] = useState('');
    const [successModal, setSuccessModal] = useState(null);
    const [resourcePreviews, setResourcePreviews] = useState([]);

    const [change, setChange] = useState(0);

    const types = useMemo(() => ([
        "Suits",
        "kurta",
    ]), []);
    const [category, setCategory] = useState(types[0]);

    const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
    const categoryDropdownRef = useRef(null);
    const [fabrics, setFabrics] = useState([]);
    const [selectedFabricObj, setSelectedFabricObj] = useState(null);
    const [editSelectedFabricObj, setEditSelectedFabricObj] = useState(null);
    const [fabricPickerOpen, setFabricPickerOpen] = useState(false);
    const [fabricPickerTarget, setFabricPickerTarget] = useState('create');
    const [fabricPickerSearch, setFabricPickerSearch] = useState('');
    const [fabricPickerBrandFilter, setFabricPickerBrandFilter] = useState('');
    const [fabricPickerTypeFilter, setFabricPickerTypeFilter] = useState('');
    const [fabricPickerBrandOpen, setFabricPickerBrandOpen] = useState(false);
    const [fabricPickerTypeOpen, setFabricPickerTypeOpen] = useState(false);
    const fabricPickerBrandRef = useRef(null);
    const fabricPickerTypeRef = useRef(null);

    const [tuxedoSearch, setTuxedoSearch] = useState('');
    const [tuxedoCategoryFilter, setTuxedoCategoryFilter] = useState('all');
    const [editRowId, setEditRowId] = useState(null);
    const [editName, setEditName] = useState('');
    const [editLoading, setEditLoading] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState({ open: false, tuxedo: null });
    const [deletingTuxedo, setDeletingTuxedo] = useState(false);

    const getTuxedoCollection = (cat) => db.collection('Fabric').doc(cat).collection('tuxedo');
    const getTuxedoDocId = (item) => item?.doc || item?.id;
    const getTuxedoCategory = (item) => item?.__category || category;

    const createFabricSnapshot = (fabric) => {
        if (!fabric) return null;
        return {
            id: fabric.id || '',
            name: fabric.name || '',
            src: fabric.src || '',
            brand: fabric.brand || '',
            color: fabric.color || '',
            fabricType: fabric.fabricType || '',
            width: fabric.width || '',
            pattern: fabric.pattern || '',
            material: fabric.material || '',
            weight: fabric.weight || '',
            weave: fabric.weave || '',
            brandImg: fabric.brandImg || '',
        };
    };

    const getFabricSummaryFromItem = (item) => {
        if (!item) return null;
        if (!item.fabricId && !item.fabricName && !item.srcFromFabric) return null;
        return {
            id: item.fabricId || '',
            name: item.fabricName || '',
            src: item.src || '',
            brand: item.fabricBrand || '',
            color: item.fabricColor || '',
            fabricType: item.fabricType || '',
            width: item.fabricWidth || '',
            pattern: item.fabricPattern || '',
            material: item.fabricMaterial || '',
            weight: item.fabricWeight || '',
            weave: item.fabricWeave || '',
            brandImg: item.fabricBrandImg || '',
        };
    };

    const resetFabricPicker = () => {
        setFabricPickerSearch('');
        setFabricPickerBrandFilter('');
        setFabricPickerTypeFilter('');
        setFabricPickerBrandOpen(false);
        setFabricPickerTypeOpen(false);
    };

    const openFabricPicker = (target) => {
        resetFabricPicker();
        setFabricPickerTarget(target);
        setFabricPickerOpen(true);
    };

    const closeFabricPicker = () => {
        setFabricPickerOpen(false);
        resetFabricPicker();
    };

    const resetForm = () => {
        setFormData({ name: '', resources: [], fabricId: '' });
        setSelectedFabricObj(null);
        setResourcePreviews([]);
    };

    useEffect(() => {
        const fetchFabrics = async () => {
            const data = await getData(db.collection('Fabric').doc('Suits').collection('fabrics'));
            setFabrics(data || []);
        };

        fetchFabrics();
    }, [change]);

    useEffect(() => {
        const fetchTuxedo = async () => {
            const categoryRows = await Promise.all(
                types.map(async (cat) => {
                    const tuxedoData = await getData(getTuxedoCollection(cat));
                    return (tuxedoData || []).map((item) => ({ ...item, __category: cat }));
                })
            );

            setTuxedo(categoryRows.flat());
        };

        fetchTuxedo();
    }, [change, types]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (categoryDropdownRef.current && !categoryDropdownRef.current.contains(event.target)) {
                setCategoryDropdownOpen(false);
            }
            if (fabricPickerBrandRef.current && !fabricPickerBrandRef.current.contains(event.target)) {
                setFabricPickerBrandOpen(false);
            }
            if (fabricPickerTypeRef.current && !fabricPickerTypeRef.current.contains(event.target)) {
                setFabricPickerTypeOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleNameChange = (e) => {
        setFormData({ ...formData, name: e.target.value });
    };

    const handleResourcesUpload = (e) => {
        const files = Array.from(e.target.files);
        setFormData({ ...formData, resources: [...formData.resources, ...files] });
        const previews = files.map((file) => URL.createObjectURL(file));
        setResourcePreviews((prev) => [...prev, ...previews]);
    };

    const handleFabricPick = (fabric) => {
        const snapshot = createFabricSnapshot(fabric);
        if (!snapshot) return;

        if (fabricPickerTarget === 'edit') {
            setEditSelectedFabricObj(snapshot);
        } else {
            setSelectedFabricObj(snapshot);
            setFormData((prev) => ({ ...prev, fabricId: snapshot.id || snapshot.name || '' }));
        }

        closeFabricPicker();
    };

    const removeResource = (index) => {
        const newResources = formData.resources.filter((_, i) => i !== index);
        const newPreviews = resourcePreviews.filter((_, i) => i !== index);
        setFormData({ ...formData, resources: newResources });
        setResourcePreviews(newPreviews);
    };

    const startEdit = (item) => {
        setEditRowId(getTuxedoDocId(item));
        setEditName(item.name || '');
        setEditSelectedFabricObj(getFabricSummaryFromItem(item));
    };

    const cancelEdit = () => {
        setEditRowId(null);
        setEditName('');
        setEditSelectedFabricObj(null);
    };

    const handleUpdateTuxedo = async (item) => {
        if (!item) return;

        const docId = getTuxedoDocId(item);
        const itemCategory = getTuxedoCategory(item);
        const nextName = String(editName || '').trim();

        if (!docId || !itemCategory) return;
        if (!nextName) {
            alert('Please enter a tuxedo name.');
            return;
        }

        setEditLoading(true);
        try {
            const updateData = { name: nextName };
            const hasFabricChanged = !!(
                editSelectedFabricObj && (
                    editSelectedFabricObj.id !== (item.fabricId || '') ||
                    editSelectedFabricObj.name !== (item.fabricName || '') ||
                    editSelectedFabricObj.src !== (item.src || '')
                )
            );

            if (hasFabricChanged) {
                if (item.src && !item.srcFromFabric && item.src !== editSelectedFabricObj.src) {
                    try { await deleteFileByUrl(item.src); } catch (error) { console.log('old tuxedo icon cleanup skipped', error); }
                }

                Object.assign(updateData, {
                    src: editSelectedFabricObj.src,
                    srcFromFabric: true,
                    fabricId: editSelectedFabricObj.id || editSelectedFabricObj.name || '',
                    fabricName: editSelectedFabricObj.name || '',
                    fabricBrand: editSelectedFabricObj.brand || '',
                    fabricColor: editSelectedFabricObj.color || '',
                    fabricType: editSelectedFabricObj.fabricType || '',
                    fabricWidth: editSelectedFabricObj.width || '',
                    fabricPattern: editSelectedFabricObj.pattern || '',
                    fabricMaterial: editSelectedFabricObj.material || '',
                    fabricWeight: editSelectedFabricObj.weight || '',
                    fabricWeave: editSelectedFabricObj.weave || '',
                    fabricBrandImg: editSelectedFabricObj.brandImg || '',
                });
            }

            const collRef = getTuxedoCollection(itemCategory);
            await collRef.doc(docId).set(updateData, { merge: true });

            setTuxedo((prev) => (prev || []).map((entry) => {
                const sameId = getTuxedoDocId(entry) === docId;
                const sameCategory = getTuxedoCategory(entry) === itemCategory;
                return sameId && sameCategory ? { ...entry, ...updateData } : entry;
            }));
            cancelEdit();
        } catch (error) {
            console.error('Error updating tuxedo:', error);
            alert('Failed to update the tuxedo. Please try again.');
        } finally {
            setEditLoading(false);
        }
    };

    const handleDeleteTuxedo = async (item) => {
        if (!item) return;

        const docId = getTuxedoDocId(item);
        const itemCategory = getTuxedoCategory(item);
        if (!docId || !itemCategory) return;

        try {
            setDeletingTuxedo(true);

            const urls = [
                ...(item.src && !item.srcFromFabric ? [item.src] : []),
                ...Object.values(item.resources || {}),
                ...(item.other_images || []),
            ].filter(Boolean);

            await Promise.all(urls.map((url) => deleteFileByUrl(url)));

            const collRef = getTuxedoCollection(itemCategory);
            const styleRef = collRef.doc(docId).collection('style');
            const resourceKeys = Object.keys(item.resources || {});
            await Promise.all(resourceKeys.map((key) => styleRef.doc(key).delete()));
            await collRef.doc(docId).delete();

            setTuxedo((prev) => (prev || []).filter((entry) => {
                const sameId = getTuxedoDocId(entry) === docId;
                const sameCategory = getTuxedoCategory(entry) === itemCategory;
                return !(sameId && sameCategory);
            }));

            if (editRowId === docId) cancelEdit();
            setDeleteConfirm({ open: false, tuxedo: null });
        } catch (error) {
            console.error('Error deleting tuxedo:', error);
            alert('Unable to delete the tuxedo. Please try again.');
        } finally {
            setDeletingTuxedo(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedFabricObj || !selectedFabricObj.src || formData.resources.length === 0 || formData.name.trim().length === 0) {
            alert('Please fill name, select a fabric, and upload required render images.');
            return;
        }

        const totalUploads = formData.resources.length || 1;
        setUploadTotal(totalUploads);
        setUploadProgress(0);
        setUploadStatus('Uploading render images...');
        setLoading(true);
        try {
            const id = new Date().getTime().toString();

            const resource_urls = {};
            for (let i = 0; i < formData.resources.length; i++) {
                const url = await handleFireBaseUpload(`${id}_resource_${i}`, formData.resources[i], `Tuxedo/${category}/${id}`);
                resource_urls[`${formData.resources[i].name.replace(" ", "").split(".")[0]}`] = url;
                setUploadProgress((prev) => prev + 1);
            }

            setUploadStatus('Saving to database...');
            const coll_ref = getTuxedoCollection(category);
            const styleRef = coll_ref.doc(id).collection("style");

            var batch = db.batch()
            Object.keys(resource_urls).forEach((doc1) => {
                var docRef = styleRef.doc(doc1);
                batch.set(docRef, { "src": resource_urls[doc1] });
            });
            await batch.commit()

            await addData(coll_ref, id, {
                id,
                name: formData.name.trim(),
                src: selectedFabricObj.src,
                srcFromFabric: true,
                fabricId: selectedFabricObj.id || selectedFabricObj.name || '',
                fabricName: selectedFabricObj.name || '',
                fabricBrand: selectedFabricObj.brand || '',
                fabricColor: selectedFabricObj.color || '',
                fabricType: selectedFabricObj.fabricType || '',
                fabricWidth: selectedFabricObj.width || '',
                fabricPattern: selectedFabricObj.pattern || '',
                fabricMaterial: selectedFabricObj.material || '',
                fabricWeight: selectedFabricObj.weight || '',
                fabricWeave: selectedFabricObj.weave || '',
                fabricBrandImg: selectedFabricObj.brandImg || '',
                resources: resource_urls,
                other_images: []
            });

            setSuccessModal({
                id,
                name: formData.name.trim(),
                category,
                fabric: selectedFabricObj.name || selectedFabricObj.id || '-',
                resourcesCount: Object.keys(resource_urls).length,
            });
            setChange((prev) => prev + 1);
            resetForm();
        } catch (error) {
            console.error('Error uploading tuxedo:', error);
            alert('Failed to upload tuxedo. Please try again.');
        } finally {
            setLoading(false);
            setUploadStatus('');
        }
    };

    const filteredTuxedos = (Tuxedo || []).filter((t) => {
        if (tuxedoCategoryFilter !== 'all' && (t.__category || '').toLowerCase() !== tuxedoCategoryFilter.toLowerCase()) return false;
        if (tuxedoSearch && !JSON.stringify(t).toLowerCase().includes(tuxedoSearch.toLowerCase())) return false;
        return true;
    });

    const pickerFabrics = fabrics || [];
    const pickerBrandsList = Array.from(new Set(pickerFabrics.map((f) => f.brand).filter(Boolean)));
    const pickerTypesList = Array.from(new Set(pickerFabrics.map((f) => f.fabricType).filter(Boolean)));
    const pickerSelectedFabric = fabricPickerTarget === 'edit' ? editSelectedFabricObj : selectedFabricObj;
    const filteredFabrics = pickerFabrics.filter((f) => {
        if (fabricPickerBrandFilter && String(f.brand || '').toLowerCase() !== fabricPickerBrandFilter.toLowerCase()) return false;
        if (fabricPickerTypeFilter && String(f.fabricType || '').toLowerCase() !== fabricPickerTypeFilter.toLowerCase()) return false;
        if (fabricPickerSearch && !JSON.stringify(f).toLowerCase().includes(fabricPickerSearch.toLowerCase())) return false;
        return true;
    });

    return (
        <div className='button_upload_page button-upload-premium-page tuxedo-upload-page'>
            <div className='button_upload_form fabric-modern button-upload-premium-form'>
                <form onSubmit={handleSubmit} className="button-upload-premium-fields">
                    <div className="f-inputs">
                        <label className="button-upload-label">Name <span className="text-red-500">*</span></label>
                        <input
                            type="text"
                            placeholder="Enter tuxedo name"
                            name="name"
                            value={formData.name}
                            onChange={handleNameChange}
                        />
                    </div>

                    <div className="f-inputs" ref={categoryDropdownRef}>
                        <label className="button-upload-label">Category <span className="text-red-500">*</span></label>
                        <div className="fabric-custom-select">
                            <button type="button" className="fabric-custom-select-trigger" onClick={() => setCategoryDropdownOpen((v) => !v)}>
                                <span>{category}</span>
                                <span className={`fabric-custom-select-arrow ${categoryDropdownOpen ? "open" : ""}`}>▾</span>
                            </button>
                            {categoryDropdownOpen && (
                                <div className="fabric-custom-select-menu">
                                    {types.map((t) => (
                                        <button
                                            type="button"
                                            key={t}
                                            className={`fabric-custom-select-option ${category === t ? "active" : ""}`}
                                            onClick={() => {
                                                setCategory(t);
                                                setCategoryDropdownOpen(false);
                                                setSelectedFabricObj(null);
                                                setFormData((prev) => ({ ...prev, fabricId: '' }));
                                            }}
                                        >
                                            {t}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="f-inputs">
                        <label className="button-upload-label">Fabric <span className="text-red-500">*</span></label>
                        <div className={`outfit-inline-fabric-select button-fabric-picker ${selectedFabricObj ? 'outfit-inline-fabric-select-active' : ''}`}>
                            {selectedFabricObj ? (
                                <div className="outfit-inline-fabric-value">
                                    <img src={selectedFabricObj.src} alt={selectedFabricObj.name || 'Fabric'} />
                                    <div className="outfit-inline-fabric-copy">
                                        <strong>{selectedFabricObj.name || 'Untitled'}</strong>
                                        <span>
                                            {selectedFabricObj.brand || '-'}
                                            {selectedFabricObj.color ? ` | ${selectedFabricObj.color}` : ''}
                                        </span>
                                        <small>This fabric preview will be used as tuxedo cover image.</small>
                                    </div>
                                    <div className="button-fabric-picker-actions">
                                        <button type="button" className="outfit-inline-fabric-remove" onClick={() => openFabricPicker('create')}>
                                            Change
                                        </button>
                                        <button
                                            type="button"
                                            className="outfit-inline-fabric-remove button-fabric-picker-clear"
                                            onClick={() => {
                                                setSelectedFabricObj(null);
                                                setFormData((prev) => ({ ...prev, fabricId: '' }));
                                            }}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <button type="button" className="button-fabric-picker-trigger" onClick={() => openFabricPicker('create')}>
                                    <span className="button-fabric-picker-trigger-label">Select any fabric</span>
                                    <span className="button-fabric-picker-trigger-arrow">›</span>
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="f-inputs">
                        <div className="fabric-file-title"><b>Upload Render <span className="text-red-500">*</span></b></div>
                        <input
                            className="fabric-file-input"
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={handleResourcesUpload}
                            required
                        />
                        {resourcePreviews.length > 0 && (
                            <div className="tuxedo-inline-previews">
                                {resourcePreviews.map((preview, idx) => (
                                    <div className="tuxedo-inline-preview-item" key={`res-${idx}`}>
                                        <img src={preview} alt={`render-${idx}`} />
                                        <button type="button" className="tuxedo-inline-remove" onClick={() => removeResource(idx)} aria-label="Remove">×</button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {loading ? (
                        <div className="outfit-upload-progress">
                            <div className="outfit-upload-progress-top">
                                <span>{uploadStatus || 'Uploading...'}</span>
                                <strong>{uploadTotal ? Math.floor((uploadProgress / uploadTotal) * 100) : 0}%</strong>
                            </div>
                            <div className="outfit-upload-progress-track">
                                <div
                                    className="outfit-upload-progress-fill"
                                    style={{ width: `${uploadTotal ? (uploadProgress / uploadTotal) * 100 : 0}%` }}
                                />
                            </div>
                            <div className="outfit-upload-progress-meta">
                                {Math.min(uploadProgress, uploadTotal)} / {uploadTotal} files uploaded
                            </div>
                        </div>
                    ) : (
                        <button type="submit" className="fabric-submit-btn">
                            Upload Tuxedo
                        </button>
                    )}
                </form>
            </div>

            <div className="button-upload-list-shell">
                <h2 className="button-upload-list-title">Uploaded Tuxedos</h2>
                <div className="button-upload-filterbar">
                    <div className="button-upload-filter-switcher">
                        <button
                            type="button"
                            className={`button-upload-filter-chip ${tuxedoCategoryFilter === 'all' ? 'button-upload-filter-chip-active' : ''}`}
                            onClick={() => setTuxedoCategoryFilter('all')}
                        >
                            all
                        </button>
                        {types.map((t) => (
                            <button
                                key={t}
                                type="button"
                                className={`button-upload-filter-chip ${tuxedoCategoryFilter === t ? 'button-upload-filter-chip-active' : ''}`}
                                onClick={() => setTuxedoCategoryFilter(t)}
                            >
                                {t}
                            </button>
                        ))}
                    </div>
                    <div className="edit-fabric-search-box button-upload-search-box">
                        <input
                            className="search_fabric_clothes"
                            placeholder="Search tuxedo"
                            value={tuxedoSearch}
                            onChange={(e) => setTuxedoSearch(e.target.value)}
                        />
                        <img src={sh} alt="Search" />
                    </div>
                </div>

                <div className='button_uploads button-upload-list'>
                    {filteredTuxedos.length === 0 ? (
                        <div className="add-brand-empty">No tuxedos found.</div>
                    ) : (
                        filteredTuxedos.map((e, i) => (
                            <div className='button_upload_card button-upload-premium-card' key={e.id || i}>
                                <div className="button-upload-card-actions">
                                    <button type="button" className="button-upload-edit-icon-btn" onClick={() => startEdit(e)} aria-label="Edit tuxedo">
                                        ✎
                                    </button>
                                    <button type="button" className="button-upload-edit-icon-btn button-upload-delete-icon-btn" onClick={() => setDeleteConfirm({ open: true, tuxedo: e })} aria-label="Delete tuxedo">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                            <polyline points="3 6 5 6 21 6"></polyline>
                                            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                                            <path d="M10 11v6M14 11v6"></path>
                                            <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path>
                                        </svg>
                                    </button>
                                </div>
                                <div className="button-upload-card-image-wrap">
                                    <img src={e.src} alt={e.name || 'Tuxedo'} className="button-upload-card-image" />
                                </div>
                                <div className="button-upload-card-details">
                                    <div className="button-upload-card-name" title={e.name || '-'}>{e.name || 'Untitled'}</div>
                                    <div className="button-upload-card-specs">
                                        <div className="button-upload-spec-row">
                                            <span className="button-upload-spec-label">Category</span>
                                            <span className="button-upload-spec-value">{e.__category || '-'}</span>
                                        </div>
                                        <div className="button-upload-spec-row">
                                            <span className="button-upload-spec-label">Renders</span>
                                            <span className="button-upload-spec-value">{e.resources ? Object.keys(e.resources).length : 0}</span>
                                        </div>
                                        <div className="button-upload-spec-row">
                                            <span className="button-upload-spec-label">Fabric</span>
                                            <span className="button-upload-spec-value">{e.fabricName || '-'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>

            {editRowId && (() => {
                const item = (Tuxedo || []).find((entry) => getTuxedoDocId(entry) === editRowId)
                if (!item) return null
                const currentFabric = editSelectedFabricObj || getFabricSummaryFromItem(item)
                return (
                    <div className="recom-modal-backdrop" onClick={cancelEdit}>
                        <div className="recom-modal add-brand-edit-modal" onClick={(ev) => ev.stopPropagation()}>
                            <div className="recom-modal-header">
                                <div>
                                    <h3>Edit Tuxedo</h3>
                                    <p>Update the tuxedo name or switch the linked fabric preview.</p>
                                </div>
                                <button type="button" className="recom-modal-close" onClick={cancelEdit} aria-label="Close">×</button>
                            </div>
                            <div className="recom-modal-body add-brand-edit-body">
                                <div className="f-inputs">
                                    <label className="button-upload-label">Name</label>
                                    <input type="text" value={editName} onChange={(e) => setEditName(e.target.value)} />
                                </div>
                                <div className="f-inputs">
                                    <label className="button-upload-label">Category</label>
                                    <input type="text" value={getTuxedoCategory(item)} disabled />
                                </div>
                                <div className="f-inputs">
                                    <label className="button-upload-label">Fabric</label>
                                    <div className={`outfit-inline-fabric-select button-fabric-picker ${currentFabric ? 'outfit-inline-fabric-select-active' : ''}`}>
                                        {currentFabric ? (
                                            <div className="outfit-inline-fabric-value">
                                                <img src={currentFabric.src} alt={currentFabric.name || 'Fabric'} />
                                                <div className="outfit-inline-fabric-copy">
                                                    <strong>{currentFabric.name || 'Linked fabric'}</strong>
                                                    <span>
                                                        {currentFabric.brand || '-'}
                                                        {currentFabric.color ? ` | ${currentFabric.color}` : ''}
                                                    </span>
                                                    <small>Choose another fabric to replace the tuxedo cover image.</small>
                                                </div>
                                                <div className="button-fabric-picker-actions">
                                                    <button type="button" className="outfit-inline-fabric-remove" onClick={() => openFabricPicker('edit')}>
                                                        Change
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <button type="button" className="button-fabric-picker-trigger" onClick={() => openFabricPicker('edit')}>
                                                <span className="button-fabric-picker-trigger-label">Select fabric</span>
                                                <span className="button-fabric-picker-trigger-arrow">›</span>
                                            </button>
                                        )}
                                    </div>
                                </div>
                                <div className="button-upload-card-specs tuxedo-edit-stats">
                                    <div className="button-upload-spec-row">
                                        <span className="button-upload-spec-label">Fabric</span>
                                        <span className="button-upload-spec-value">{currentFabric?.name || item.fabricName || '-'}</span>
                                    </div>
                                    <div className="button-upload-spec-row">
                                        <span className="button-upload-spec-label">Renders</span>
                                        <span className="button-upload-spec-value">{item.resources ? Object.keys(item.resources).length : 0}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="recom-modal-footer">
                                <button
                                    type="button"
                                    className="fabric-submit-btn recom-modal-clear add-brand-delete-btn"
                                    onClick={() => setDeleteConfirm({ open: true, tuxedo: item })}
                                    disabled={editLoading}
                                >
                                    Delete
                                </button>
                                <div className="recom-modal-actions">
                                    <button type="button" className="fabric-submit-btn recom-modal-clear" onClick={cancelEdit} disabled={editLoading}>Cancel</button>
                                    <button type="button" className="fabric-submit-btn recom-modal-done" onClick={() => handleUpdateTuxedo(item)} disabled={editLoading}>
                                        {editLoading ? 'Saving...' : 'Save Changes'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })()}

            {deleteConfirm.open && deleteConfirm.tuxedo && (
                <div className="recom-modal-backdrop" onClick={() => !deletingTuxedo && setDeleteConfirm({ open: false, tuxedo: null })}>
                    <div className="recom-modal add-brand-delete-modal" onClick={(ev) => ev.stopPropagation()}>
                        <div className="recom-modal-header">
                            <div>
                                <h3>Delete Tuxedo</h3>
                                <p>Are you sure you want to delete <b>{deleteConfirm.tuxedo.name || 'this tuxedo'}</b>? This action cannot be undone.</p>
                            </div>
                            <button type="button" className="recom-modal-close" onClick={() => !deletingTuxedo && setDeleteConfirm({ open: false, tuxedo: null })} aria-label="Close">×</button>
                        </div>
                        <div className="recom-modal-footer">
                            <div></div>
                            <div className="recom-modal-actions">
                                <button type="button" className="fabric-submit-btn recom-modal-clear" onClick={() => setDeleteConfirm({ open: false, tuxedo: null })} disabled={deletingTuxedo}>Cancel</button>
                                <button type="button" className="fabric-submit-btn recom-modal-done add-brand-confirm-delete" onClick={() => handleDeleteTuxedo(deleteConfirm.tuxedo)} disabled={deletingTuxedo}>
                                    {deletingTuxedo ? 'Deleting...' : 'Confirm Delete'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {fabricPickerOpen && (
                <div className="recom-modal-backdrop" onClick={closeFabricPicker}>
                    <div className="recom-modal button-fabric-picker-modal" onClick={(ev) => ev.stopPropagation()}>
                        <div className="recom-modal-header">
                            <div>
                                <h3>Select Fabric</h3>
                                <p>Pick a fabric to use as tuxedo cover image. {filteredFabrics.length} fabric{filteredFabrics.length === 1 ? '' : 's'} available.</p>
                            </div>
                            <button type="button" className="recom-modal-close" onClick={closeFabricPicker} aria-label="Close">×</button>
                        </div>

                        <div className="recom-modal-filterbar">
                            <div className="button-fabric-picker-filters">
                                <div className="button-fabric-picker-filter" ref={fabricPickerBrandRef}>
                                    <div className="fabric-custom-select">
                                        <button type="button" className="fabric-custom-select-trigger edit-fabric-select-trigger" onClick={() => setFabricPickerBrandOpen((v) => !v)}>
                                            <span>{fabricPickerBrandFilter || 'All Brands'}</span>
                                            <span className={`fabric-custom-select-arrow ${fabricPickerBrandOpen ? 'open' : ''}`}>▾</span>
                                        </button>
                                        {fabricPickerBrandOpen && (
                                            <div className="fabric-custom-select-menu">
                                                <button type="button" className={`fabric-custom-select-option ${fabricPickerBrandFilter === '' ? 'active' : ''}`} onClick={() => { setFabricPickerBrandFilter(''); setFabricPickerBrandOpen(false); }}>All Brands</button>
                                                {pickerBrandsList.map((val) => (
                                                    <button type="button" key={val} className={`fabric-custom-select-option ${fabricPickerBrandFilter === val ? 'active' : ''}`} onClick={() => { setFabricPickerBrandFilter(val); setFabricPickerBrandOpen(false); }}>{val}</button>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="button-fabric-picker-filter" ref={fabricPickerTypeRef}>
                                    <div className="fabric-custom-select">
                                        <button type="button" className="fabric-custom-select-trigger edit-fabric-select-trigger" onClick={() => setFabricPickerTypeOpen((v) => !v)}>
                                            <span>{fabricPickerTypeFilter || 'All Types'}</span>
                                            <span className={`fabric-custom-select-arrow ${fabricPickerTypeOpen ? 'open' : ''}`}>▾</span>
                                        </button>
                                        {fabricPickerTypeOpen && (
                                            <div className="fabric-custom-select-menu">
                                                <button type="button" className={`fabric-custom-select-option ${fabricPickerTypeFilter === '' ? 'active' : ''}`} onClick={() => { setFabricPickerTypeFilter(''); setFabricPickerTypeOpen(false); }}>All Types</button>
                                                {pickerTypesList.map((val) => (
                                                    <button type="button" key={val} className={`fabric-custom-select-option ${fabricPickerTypeFilter === val ? 'active' : ''}`} onClick={() => { setFabricPickerTypeFilter(val); setFabricPickerTypeOpen(false); }}>{val}</button>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="recom-modal-search">
                                <input type="text" placeholder="Search fabric by name, brand, color..." value={fabricPickerSearch} onChange={(ev) => setFabricPickerSearch(ev.target.value)} />
                                <img src={sh} alt="Search" />
                            </div>
                        </div>

                        <div className="recom-modal-body">
                            {filteredFabrics.length === 0 ? (
                                <div className="recom-modal-empty">
                                    No fabrics found{fabricPickerBrandFilter ? ` for brand ${fabricPickerBrandFilter}` : ''}{fabricPickerTypeFilter ? ` of type ${fabricPickerTypeFilter}` : ''}{fabricPickerSearch ? ` matching "${fabricPickerSearch}"` : ''}.
                                </div>
                            ) : (
                                <div className="button-fabric-picker-grid">
                                    {filteredFabrics.map((f) => {
                                        const isSelected = pickerSelectedFabric && ((pickerSelectedFabric.id && pickerSelectedFabric.id === f.id) || (!pickerSelectedFabric.id && pickerSelectedFabric.name === f.name))
                                        return (
                                            <div
                                                key={f.id}
                                                className={`outfit-fabric-card ${isSelected ? 'outfit-fabric-card-active' : ''}`}
                                                onClick={() => handleFabricPick(f)}
                                            >
                                                <img src={f.src} alt={f.name} className="outfit-fabric-card-image" />
                                                <div className="outfit-fabric-card-info">
                                                    <h5>{f.name}</h5>
                                                    <p>{f.brand || '-'}</p>
                                                    <span>{f.color || '-'}{f.width ? ` · ${f.width}` : ''}</span>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {successModal && (
                <div className="outfit-success-modal-backdrop">
                    <div className="outfit-success-modal">
                        <div className="outfit-success-modal-badge">Upload Successful</div>
                        <h3>Tuxedo uploaded successfully</h3>
                        <div className="outfit-success-modal-grid">
                            <div><span>ID</span><strong>{successModal.id}</strong></div>
                            <div><span>Name</span><strong>{successModal.name}</strong></div>
                            <div><span>Category</span><strong>{successModal.category}</strong></div>
                            <div><span>Fabric</span><strong>{successModal.fabric}</strong></div>
                            <div><span>Renders</span><strong>{successModal.resourcesCount}</strong></div>
                        </div>
                        <button type="button" className="fabric-submit-btn outfit-success-close" onClick={() => setSuccessModal(null)}>
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Tuxedo_upload;
